// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleCallToAction_container__yB4MC","ctaButton":"ArticleCallToAction_ctaButton__39Ecu","text":"ArticleCallToAction_text__zqQI_"};